var r={REFRESH_TOKEN:"rt"};export{r as COOKIES};
//# sourceMappingURL=constants.js.map
